/** Shared mapping so UI never shows internal API/debug errors. */

export const CUSTOMER_ERRORS = {
  network: 'We couldn’t reach the server. Check your connection and try again.',
  unavailable: 'Something went wrong. Please try again shortly.',
  session: 'Please sign in to continue.',
  forbidden: 'You do not have permission to do this.',
  notFound: 'We couldn’t find what you were looking for.',
  generic: 'Something went wrong. Please try again shortly.'
};

export const looksInternalError = (text) => {
  const value = String(text || '').trim();
  if (!value) return true;
  const lower = value.toLowerCase();
  const trimmed = value.trim();
  return (
    trimmed.startsWith('{') ||
    trimmed.startsWith('[') ||
    /\/[a-z0-9_-]+\/[a-z0-9_-]+/.test(lower) ||
    /\b(get|post|put|patch|delete)\s+\//.test(lower) ||
    lower.includes('devtools') ||
    lower.includes('allowed_origins') ||
    lower.includes('migration') ||
    lower.includes('sql/') ||
    lower.includes('traceback') ||
    lower.includes('localstorage') ||
    lower.includes('access_token') ||
    lower.includes('redeploy') ||
    lower.includes('psycopg') ||
    lower.includes('sqlalchemy') ||
    lower.includes('internal server') ||
    lower.includes('stripe_error') ||
    lower.includes('execute-api') ||
    lower.includes('http error') ||
    lower.includes('request failed (') ||
    lower.includes('validation failed (') ||
    lower.includes('cors') ||
    lower.includes('"loc"') ||
    lower.includes('network/cors') ||
    /\b(502|503|504|500)\b/.test(lower)
  );
};

export const toCustomerError = (message, { status, fallback } = {}) => {
  const value = String(message || '').trim();
  const lower = value.toLowerCase();
  if (status === 401 || lower.includes('token has expired') || lower.includes('invalid token')) {
    return fallback || CUSTOMER_ERRORS.session;
  }
  if (status === 403) return fallback || CUSTOMER_ERRORS.forbidden;
  if (status === 404) return fallback || CUSTOMER_ERRORS.notFound;
  if (status === 502 || status === 503 || status === 504 || status >= 500) {
    return fallback || CUSTOMER_ERRORS.unavailable;
  }
  if (
    lower.includes('failed to fetch') ||
    lower.includes('networkerror') ||
    lower.includes('network request failed') ||
    lower.includes('unable to reach')
  ) {
    return fallback || CUSTOMER_ERRORS.network;
  }
  if (value && !looksInternalError(value)) return value;
  return fallback || CUSTOMER_ERRORS.generic;
};

export const logInternalError = (label, extra) => {
  if (typeof console !== 'undefined' && console.warn) {
    console.warn(label, extra);
  }
};
